import { Map, Marker } from "../../Map"
import React from "react"

export default ({
  defaultCenter,
  fullAddress = false,
  displayAddress = false,
  lat,
  lng,
  markerTitle,
}) => {
  return (
    <div className="container">
      <div className="space-profile-location bottom-line">
        <div className="row">
          <div className="col-sm-12">
            <h2>Location</h2>
            {fullAddress && (
              <p>
                <a
                  href={`https://maps.google.com/?q=${fullAddress}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {displayAddress}
                </a>
              </p>
            )}

            <div className="home-page-map-container">
              <Map
                center={
                  typeof window !== "undefined" && window.innerWidth > 768
                    ? defaultCenter
                    : { lat, lng }
                }
                defaultZoom={13}
              >
                <Marker text={markerTitle} lat={lat} lng={lng} />
              </Map>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
